import { AnnualWheelActivitySelectorDialogProps } from "./AnnualWheelActivitySelectorDialog.tsx";
import { SelectableAnnualWheelActivityTableRow } from "@common/components/selectableAnnualWheelActivityTable/SelectableAnnualWheelActivityTable.types.ts";
import { put } from "@common/api/apiShared.ts";
import { useState } from "react";
import { useDotLegalQuery, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useAnnualWheelActivitySelectorDialog(props: AnnualWheelActivitySelectorDialogProps) {
    const [selectedActivities, setSelectedActivities] = useState<Array<string>>([]);

    const url = `/frameworkControls/${props.controlId}/selectable-annual-wheel-activities`;
    const { isLoading, data } = useDotLegalQuery<Array<SelectableAnnualWheelActivityTableRow>>(url);

    const addAnnualWheelActivitiesMutation = useDotLegalMutation(addAnnualWheelActivitiesApi);
    const onSaveClick = async () => {
        await addAnnualWheelActivitiesMutation.mutateAsync(selectedActivities, {
            onSuccess: () => {
                props.onAnnualWheelActivitiesSaved();
            },
        });
    };

    return {
        isLoading,
        selectableAnnnualWheelActivities: data ?? [],
        onSaveClick,
        selectedActivities,
        setSelectedActivities,
    };

    function addAnnualWheelActivitiesApi(annualWheelActivities: Array<string>) {
        return put(`/frameworkControls/${props.controlId}/annualWheelActivities`, annualWheelActivities);
    }
}
